import type { Photo } from '../../types';

interface Props {
    photo: Photo;
    isChecked: boolean;
    taggedNames: string | null;
    onCheck: () => void;
    onView: () => void;
    notSelected?: boolean;
}

export default function TagPhotoCard({ photo, isChecked, taggedNames, onCheck, onView, notSelected = false }: Props) {
    let borderColor = 'var(--color-border)';
    let badgeText = 'Untagged';
    let badgeClass = 'tag-badge untagged';

    if (!notSelected) {
        if (photo.isGroupPhoto) {
            borderColor = 'var(--color-accent)';
            badgeText = 'Group';
            badgeClass = 'tag-badge group';
        } else if (taggedNames) {
            borderColor = 'var(--color-primary)';
            badgeText = taggedNames;
            badgeClass = 'tag-badge individual';
        }
    }

    const cardClass = ['tag-photo-card', notSelected ? 'photo-card-unselected' : (isChecked ? 'checked' : '')].filter(Boolean).join(' ');

    return (
        <div
            className={cardClass}
            style={{ borderColor }}
            onClick={notSelected ? undefined : onCheck}
        >
            <div className='tag-photo-img'>
                <img src={photo.thumbnailURL ?? photo.displayURL} alt={photo.originalFilename} />
                <button
                    className='tag-photo-view-btn'
                    title='View full size'
                    onClick={e => { e.stopPropagation(); onView(); }}
                >
                    ⛶
                </button>
            </div>
            <div className='tag-photo-footer' onClick={e => e.stopPropagation()}>
                {notSelected ? (
                    <span className='badge badge-unselected'>Not Selected</span>
                ) : (
                    <>
                        <label className='tag-photo-check'>
                            <input type='checkbox' checked={!!isChecked} onChange={onCheck} />
                        </label>
                        <span className={badgeClass}>{badgeText}</span>
                    </>
                )}
            </div>
        </div>
    );
}
